export const promptOptions = [
  { label: 'None', value: 'none' },
  { label: 'Login', value: 'login' },
  { label: 'Consent', value: 'consent' },
  { label: 'Select account', value: 'select_account' },
];
